import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_STICKY_COLUMNS,
  UPDATE_STICKY_COLUMNS
} from "./actionTypes"

import {
  getStickyColumnsSuccess,
  getStickyColumnsError,
  updateStickyColumnsSuccess,
  updateStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetStickyColumns() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_column_preferences`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getStickyColumnsError(error))
  }
}

function* onUpdateStickyColumns(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_column_preferences/${action?.payload?.admin_user_column_preference?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateStickyColumnsError(error))
  }
}

function* adminUserColumnPreferenceSaga() {
  yield takeEvery(GET_STICKY_COLUMNS, onGetStickyColumns)
  yield takeEvery(UPDATE_STICKY_COLUMNS, onUpdateStickyColumns)
}

export default adminUserColumnPreferenceSaga;
